import styled from 'styled-components';
import { Typography } from '../Typography';
export var ModalTitle = styled(Typography).attrs({
  variant: 'heading',
  mt: 4,
  mb: 4,
  'data-test': 'modal-title'
}).withConfig({
  displayName: "ModalTitle",
  componentId: "sc-19qcouf-0"
})([""]);